import { useState, useRef, useCallback, useContext, useEffect } from "react";
import PropTypes from "prop-types";
import { Button, Dialog, DialogTitle, DialogContent, DialogActions, DialogContentText, TextField } from "@mui/material";
import AppBackService from "../services/appback";
import { RootContext } from "../context/root-provider";

const styles = {
  textField: {
    width: "100%",
    marginBottom: "10px",
    marginTop: "6px",
  },
  heading: {
    marginTop: "10px",
  },
};

const StartSpacesTranscribeModal = ({ open, setOpen, presetUrl, refreshCallback, showSnackbar }) => {
  const [spacesUrl, setSpacesUrl] = useState("");
  const [formInvalid, setFormInvalid] = useState(false);
  const dialogContentEl = useRef();

  const { userInfo } = useContext(RootContext);

  // A link handed in from outside (dropped, pasted, or on the clipboard —
  // TT-1231) fills the field on open; the user still presses Start.
  useEffect(() => {
    if (open && presetUrl) setSpacesUrl(presetUrl);
  }, [open, presetUrl]);

  const closeModal = useCallback(() => {
    setFormInvalid(false);
    setOpen(false);
    setSpacesUrl("");
  }, [setOpen]);

  const startSpacesTranscribe = useCallback(async () => {
    if (!spacesUrl) {
      setFormInvalid(true);
      return;
    } else {
      setFormInvalid(false);
    }
    const resp = await AppBackService.startSpacesTranscribe(userInfo?.username, spacesUrl);
    if (resp && !resp.error) {
      showSnackbar("X Space transcription started!", "success");
      refreshCallback && refreshCallback();
    } else {
      showSnackbar("Unable to start X Space transcription", "error");
    }
    setOpen(false);
    setSpacesUrl("");
  }, [spacesUrl, userInfo, showSnackbar, setOpen, refreshCallback]);

  return (
    <Dialog fullWidth maxWidth="sm" open={open} onClose={closeModal}>
      <DialogTitle>X Space Transcription</DialogTitle>
      <DialogContent ref={dialogContentEl}>
        <DialogContentText sx={styles.heading}>Enter the X Space URL to start transcription.</DialogContentText>
        <TextField
          sx={styles.textField}
          error={formInvalid && !spacesUrl}
          helperText={formInvalid && !spacesUrl && "Please enter an X Space URL"}
          placeholder="X Space URL"
          value={spacesUrl}
          onChange={(e) => setSpacesUrl(e.target.value)}
          autoFocus
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={closeModal}>Cancel</Button>
        <Button onClick={startSpacesTranscribe}>Start</Button>
      </DialogActions>
    </Dialog>
  );
};

StartSpacesTranscribeModal.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.func,
  presetUrl: PropTypes.string,
  refreshCallback: PropTypes.func,
  showSnackbar: PropTypes.func,
};

export default StartSpacesTranscribeModal;
